import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { candidateActions as actions, notificationActions } from '../actions';
import { candidateService } from '../services';

/* Add candidate Sagas */
function* handleCreateCandidateRequest() {
  const action = yield take(actions.createCandidateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(candidateService.createCandidate, dataParams);
    if (res.isError) {
      yield put(actions.createCandidateError(res));

      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createCandidateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createCandidateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Add candidate Sagas */
function* handleUpdateCandidateDetailsRequest() {
  const action = yield take(actions.updateCandidateDetailsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(candidateService.updateCandidateDetails, dataParams);
    if (res.isError) {
      yield put(actions.updateCandidateDetailsError(res));

      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateCandidateDetailsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateCandidateDetailsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* Get All Candidate Sagas */
function* handleGetAllCandidateRequest() {
  const action = yield take(actions.getAllCandidateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(candidateService.getAllCandidate, dataParams);

    if (res.isError) {
      yield put(actions.getAllCandidateError(res));

    } else {
      yield put(actions.getAllCandidateSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllCandidateError());
  }
}



/* -----------Watchers------------- */
function* handleCreateCandidateWatcher() {
  yield takeEvery(
    actions.createCandidateRequest,
    handleCreateCandidateRequest,
  );
}

function* handleUpdateCandidateDetailsWatcher() {
  yield takeEvery(
    actions.updateCandidateDetailsRequest,
    handleUpdateCandidateDetailsRequest,
  );
}

function* handleGetAllCandidateWatcher() {
  yield takeEvery(
    actions.getAllCandidateRequest,
    handleGetAllCandidateRequest,
  );
}


function* rootCandidateSaga() {
  yield all([
    handleCreateCandidateRequest(),
    handleCreateCandidateWatcher(),

    handleUpdateCandidateDetailsRequest(),
    handleUpdateCandidateDetailsWatcher(),

    handleGetAllCandidateRequest(),
    handleGetAllCandidateWatcher(),
  ]);
}

export default rootCandidateSaga;
